import * as Schema from "effect/Schema";
import { MediaOperation } from "./media.ts";

const StepKey = Schema.String.check(
  Schema.isMinLength(1),
  Schema.isMaxLength(512),
  Schema.isPattern(/^[^\x00-\x1f\x7f]+$/),
);
export const MediaSelectionRequest = Schema.Union([
  Schema.Struct({
    action: Schema.Literal("selection.read"),
    params: Schema.Struct({ stepKey: StepKey, operation: MediaOperation }),
  }),
  Schema.Struct({
    action: Schema.Literal("selection.set"),
    params: Schema.Struct({
      stepKey: StepKey,
      operation: MediaOperation,
      modelKey: Schema.NullOr(
        Schema.String.check(Schema.isPattern(/^[a-zA-Z0-9][a-zA-Z0-9_-]{0,95}$/)),
      ),
    }),
  }),
]);
export type MediaSelectionRequest = typeof MediaSelectionRequest.Type;
export interface MediaSelection {
  readonly stepKey: string;
  readonly operation: MediaOperation;
  readonly modelKey: string | null;
  readonly updatedAt: string | null;
}
